import styled from 'styled-components'

export const OuterWrapper = styled.div`
    height: 100vh;
    width: 100vw;
    background-color: #2e2e2e;
`
export const Wrapper = styled.div`
    height: 70vh;
    width: 100vw;
    padding: 27px;
    display: flex;
    flex-direction: column;
    background: url(/assets/revamp/bgJoinClass.svg) 0 0 repeat-x;
    background-color: #2e2e2e;
    justify-content: space-between;
`

export const LogoWrapper = styled.div`
    display: flex;
    justify-content: start;
`

export const Logo = styled.img``

export const InputField = styled.input`
    width: 100%;
    padding: 8px 16px;
    font-size: 16px;
    box-shadow: none;
    color: #ffffff;
    background-color: #36383c;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    line-height: 32px;
    height: 48px;

    ::placeholder {
        color: rgba(255, 255, 255, 0.36);
        font-size: 16px;
        line-height: 32px;
        font-family: Nunito Sans;
    }
`

export const WelcomeText = styled.div`
    font-size: 28px;
    line-height: 36px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 14px;
`

export const SubText = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    margin-bottom: 14px;
`

export const InputWrapper = styled.div``

export const ActionWrapper = styled.div``

export const Button = styled.button`
    width: 100%;
    padding: 12px 16px;
    color: #ffffff;
    background: #ef5c34;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;

    background: #ef5c34;

    border: 1px solid rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    box-shadow: 0px 8px 16px rgba(17, 17, 26, 0.12),
        0px 2px 4px rgba(17, 17, 26, 0.06);
    border-radius: 32px;

    ${props => props.disabled && `opacity: 0.5;`}
`

export const ValidationError = styled.div`
    color: var(--oh-orange);
    font-size: 14px;
    margin: 10px 4px;
`
